<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a href="#" @click.prevent="$router.push({ name: 'student-profile' })" class="mr-2">
          <i class="fas fa-arrow-left"></i>
        </a>
        {{
          $t('school.academic.operation.profile_mgt.studentProfile.pageTitle')
        }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t(
            'school.academic.operation.profile_mgt.studentProfile.pageTitle'
          ),
          href: '/student-profiles'
        },
        {
          text: $t('add_new'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <!-- <ts-card-wrapper> -->
      <form-wizard :title="''" :subtitle="''" finishButtonText="Save" color="#348fe2" errorColor="red" ref="wizard"
        @on-complete="onComplete">
        <tab-content style="min-height: 370px !important;" :title="$t(
          'school.academic.operation.profile_mgt.studentProfile.profileInformation'
        )
          " icon="fas fa-user-graduate" :before-change="() => validateStep('profile-information')">
          <profile-information ref="profile-information" v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t('school.academic.operation.profile_mgt.studentProfile.contact')
          " icon="fas fa-phone-volume">
          <contact v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t(
          'school.academic.operation.profile_mgt.studentProfile.schoolInformation'
        )
          " icon="fas fa-school" :before-change="() => validateStep('school-information')">
          <school-information v-model="model" :validate="errors" :clear="clear" ref="school-information" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t('school.academic.operation.profile_mgt.studentProfile.address')
          " icon="fas fa-map-marker-alt">
          <address-form v-model="model" :validate="errors" :clear="clear" />
        </tab-content>
        <tab-content style="min-height: 370px !important;" :title="$t('school.academic.operation.profile_mgt.studentProfile.discount')
          " icon="fas fa-percent">
          <discount v-model="model" :validate="errors" :clear="clear" />
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="wizard-footer-left">
            <wizard-button v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="props.prevTab()"
              :style="'background:#e2e2e2'">
              {{
                $t(
                  'school.academic.operation.profile_mgt.studentProfile.previous'
                )
              }}
            </wizard-button>
          </div>
          <div class="wizard-footer-right">
            <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
              :style="props.fillButtonStyle" :disabled="nextStep">
              <i class="fa fa-spinner spin mr-2" v-if="nextStep"></i>
              {{
                $t('school.academic.operation.profile_mgt.parentProfile.next')
              }}
            </wizard-button>
            <wizard-button v-else @click.native="onComplete" class="wizard-footer-right finish-button"
              :style="props.fillButtonStyle" :disabled="waiting">
              <i class="fa fa-spinner spin mr-2" v-if="waiting"></i>
              {{
                props.isLastStep
                  ? $t(
                    'school.academic.operation.profile_mgt.parentProfile.done'
                  )
                  : $t(
                    'school.academic.operation.profile_mgt.parentProfile.next'
                  )
              }}
            </wizard-button>
          </div>
        </template>
      </form-wizard>
      <!-- </ts-card-wrapper> -->
    </ts-card>
  </div>
</template>

<script>
import { FormWizard, TabContent, WizardButton } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import moment from 'moment'
// components
import ProfileInformation from './component/profile-information'
import SchoolInformation from './component/school-information'
import Contact from './component/contact'
import AddressForm from './component/address'
import Discount from './component/discount'
import Compressor from 'compressorjs'

export default {
  name: 'studentProfileEdit',
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    ProfileInformation,
    SchoolInformation,
    Contact,
    AddressForm,
    Discount
  },
  data() {
    return {
      model: {
        student_id: 0,
        first_name_kh: null,
        last_name_kh: null,
        first_name_en: null,
        last_name_en: null,
        gender: null,
        date_of_birth: null,
        place_of_birth: null,
        province_code: null,
        district_code: null,
        commune_code: null,
        village_code: null,
        street_no: null,
        house_no: null,
        phone: null,
        serial_finger_print_no: null,
        email: null,
        facebook_account: null,
        photo: null,
        ac_st_id: null,
        is_card_discount: false,
        card_discount_rate: null,
        is_till_further_notice: false,
        discount_expiry_date: null,
        discount_note: null,
        discount_by_staff_id: null,
        nationality: 33,
        religious: 1,
        registered_date: moment().format('DD-MM-YYYY'),
        changed_in_from_school: null,
        changed_in_from_school_type: null,
        current_school_another_program: null,
        current_school_another_program_type: null,
        linked_in: null,
        telegram: null,
        line: null,
        we_chart: null,
        emergency_contact_person: null,
        emergency_contact_relation: null,
        emergency_contact_phone: null,
        student_parent_id: null,
        inquiry_id: null,
        cpp_id: null,
        promotion: null,
        acp_id: null,
        acps_id: null,
        level_id: [],
        student_current_status: [],
        place_of_birth_kh: null,
        is_student: true,
        is_external_candidate: false,
        discount_card_images: undefined
      },
      errors: new Errors(),
      nextStep: false,
      waiting: false,
      clear: false
    }
  },
  methods: {
    ...mapActions('studentProfile', ['uploadPhoto']),
    validateStep(name) {
      if (this.model.is_student) {
        var refToValidate = this.$refs[name]
        return refToValidate.validateForm()
      }
      return true
    },

    async onComplete() {
      const modelClone = Object.assign({}, this.model)
      this.errors = new Errors()
      this.waiting = true
      const { photo, discount_card_images } = await this.onCompressImage()

      if (photo) {
        let formData = new FormData()
        formData.append('photo', photo)
        let photo_path = await this.$store.dispatch(
          'studentProfile/uploadPhoto',
          formData
        )
        modelClone.photo = photo_path
      }

      if (discount_card_images) {
        let formData = new FormData()
        formData.append('photo', discount_card_images)
        let photo_path = await this.$store.dispatch(
          'studentProfile/uploadPhoto',
          formData
        )
        modelClone.discount_card_images = photo_path
      }

      await this.$store
        .dispatch('studentProfile/update', modelClone)
        .then(response => {
          this.clearForm()
          this.clear = true
          this.$refs.wizard.reset()
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'student-profile' })
        })
        .catch(error => {
          this.waiting = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    async onCompressImage() {
      const compres = {
        photo: undefined,
        discount_card_images: undefined
      }
      if (
        this.model.photo instanceof File ||
        this.model.photo instanceof Blob
      ) {
        compres.photo = await new Promise(resolved => {
          new Compressor(this.model.photo, {
            quality: 0.2,
            success: result => resolved(result)
          })
        })
      }

      if (
        this.model.discount_card_images instanceof File ||
        this.model.discount_card_images instanceof Blob
      ) {
        compres.discount_card_images = await new Promise(resolved => {
          new Compressor(this.model.discount_card_images, {
            quality: 0.2,
            success: result => resolved(result)
          })
        })
      }

      return compres
    },
    clearForm() {
      this.model = {
        first_name_kh: null,
        last_name_kh: null,
        first_name_en: null,
        last_name_en: null,
        gender: null,
        date_of_birth: null,
        place_of_birth: null,
        province_code: null,
        district_code: null,
        commune_code: null,
        village_code: null,
        street_no: null,
        house_no: null,
        phone: null,
        serial_finger_print_no: null,
        email: null,
        facebook_account: null,
        photo: null,
        ac_st_id: null,
        is_card_discount: false,
        card_discount_rate: null,
        is_till_further_notice: false,
        discount_expiry_date: null,
        discount_note: null,
        discount_by_staff_id: null,
        nationality: 33,
        religious: 1,
        registered_date: moment().format('DD-MM-YYYY'),
        changed_in_from_school: null,
        changed_in_from_school_type: null,
        current_school_another_program: null,
        current_school_another_program_type: null,
        linked_in: null,
        telegram: null,
        line: null,
        we_chart: null,
        emergency_contact_person: null,
        emergency_contact_relation: null,
        emergency_contact_phone: null,
        student_parent_id: null,
        inquiry_id: null,
        cpp_id: null,
        promotion: null,
        acp_id: null,
        acps_id: null,
        level_id: [],
        student_current_status: [],
        place_of_birth_kh: null,
        discount_card_images: null,
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // this.$store.commit('studentProfile/RESET_STATE')
    this.$store.commit('studentProfile/SET_EDIT_DATA', {})
    next()
  }
}
</script>
